
import { ref } from "vue";
import { useFiltrate } from "@/hooks/index";
import { useRoute } from 'vue-router'
export default {
  props: {
    transferData: {
      //数据
      type: Array,
    },
    headline: {
      //标题
      type: String,
    },
    radioCheck: {
      //是否多选
      type: Boolean,
      default: false,
    },
    unActive:{
      //选中状态
      type:Number,
      default:-1
    }
  },
  setup(props: any, cxt: any) {
    const status = ref(false);  
    let { transferData,unActive  } = props
    let route = useRoute();
    //取反展开关闭
    const browseModeClick = () => {
      status.value = !status.value;
    };
    const emptyClone = ()=>{
      check_goods_exit = []    
    }

    let {
      categoryClick,
      serviceActive,
      check_goods_exit,
      unwindList,
      remove_clones,
      overlay
    }: any = useFiltrate(props, cxt,undefined,unActive);

    return {
      status,
      browseModeClick,
      categoryClick,
      serviceActive,
      unwindList,
      check_goods_exit,
      emptyClone,
      remove_clones,
      overlay
    };
  },
};
